import { render } from "./ShoppingOrders.vue?vue&type=template&id=0f56d3dc&scoped=true"
import script from "./ShoppingOrders.vue?vue&type=script&lang=js"
export * from "./ShoppingOrders.vue?vue&type=script&lang=js"

import "./ShoppingOrders.vue?vue&type=style&index=0&id=0f56d3dc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0f56d3dc"

export default script